import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import { CheckerServiceModel } from '../../form-json.types';
import { CheckerService } from '../checker/checker.service';
import { FormCoreModule } from '../form-core.module';
import { otpResAction } from '../otp/otp.service';

@Injectable({
  providedIn: FormCoreModule
})
export class ServiceCheckerService {

  constructor(private checker: CheckerService, private actions$: Actions) { }

  check(checker: CheckerServiceModel): Observable<boolean> {
    return this.actions$.pipe(
      ofType(otpResAction),
      filter(({id}) => id === checker.relationships.service.data.id),
      map(({type, res}) => this.checker.assign(type)(res)),
      first()
    )
  }
}
